import useHttpQuery from 'data/firestore/useHttpQuery';

const useAvailableAgents = <T = unknown>() => useHttpQuery<T>({
    pathname: '/agents',
});

export default useAvailableAgents;
